import { useEffect, useState } from "react";
import { RefreshCw, Sparkles, AlertTriangle } from "lucide-react";
import { hasUnsavedChanges, unsavedContext, saveDraft } from "@/lib/unsavedChanges";
import { skipNextUnloadPrompt } from "@/lib/leaveRegistry";
import DeskConfirm from "@/components/crm/DeskConfirm";

const hhmm = (d) => (d ? new Date(d).toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" }) : "");

/** iter364 pt.2 (modèle C1) — F5 / Ctrl+R : fenêtre Le Desk « Actualiser Le Desk ? » (jamais la fenêtre du navigateur). */
export default function ReloadConfirm() {
  const [open, setOpen] = useState(false);
  const [ctx, setCtx] = useState({ dirty: false, screen: "", field: null, update: null });
  useEffect(() => {
    const onKey = (e) => {
      const isReload = e.key === "F5" || ((e.ctrlKey || e.metaKey) && (e.key === "r" || e.key === "R"));
      if (!isReload) return;
      e.preventDefault(); e.stopPropagation();
      const u = window.__deskUpdate;
      setCtx({ dirty: hasUnsavedChanges(), ...unsavedContext(), update: u?.pending ? u.publishedAt || true : null });
      setOpen(true);
    };
    window.addEventListener("keydown", onKey, true);
    return () => window.removeEventListener("keydown", onKey, true);
  }, []);
  const reload = () => { if (ctx.dirty) saveDraft(); skipNextUnloadPrompt(); window.location.reload(); };
  return (
    <DeskConfirm open={open} danger={false} icon={RefreshCw} title="Actualiser Le Desk ?" message="La page sera rechargée. Rien d'enregistré ne sera perdu." confirmLabel="Actualiser" onClose={() => setOpen(false)} onConfirm={reload} testId="reload-confirm">
      {(ctx.update || ctx.dirty) ? <>
        {ctx.update && <div className="flex items-center" style={{ gap: 8, padding: "8px 10px", borderRadius: 8, border: "1px solid #235c48", background: "#122019", color: "#4fc79c", fontSize: 11.5 }} data-testid="reload-confirm-update"><Sparkles size={14} /> Nouvelle version disponible{ctx.update !== true && ` · ${hhmm(ctx.update)}`}</div>}
        {ctx.dirty && <div className="flex items-center" style={{ gap: 8, marginTop: ctx.update ? 8 : 0, padding: "8px 10px", borderRadius: 8, border: "1px dashed #6a5226", color: "#E0A42E", fontSize: 11.5 }} data-testid="reload-confirm-dirty"><AlertTriangle size={14} /> <span>Saisie en cours : {ctx.screen}{ctx.field ? ` · ${ctx.field}` : ""}</span></div>}
      </> : null}
    </DeskConfirm>
  );
}
